// Notifications plugin. Used on Notifications page
// import Notifications from './components/NotificationPlugin'
import VeeValidate from 'vee-validate'
import GlobalComponents from './globalComponents'
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
// import SideBar from './components/SidebarPlugin'

import lineClamp from 'vue-line-clamp'

import './assets/sass/sud.scss'

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    // Vue.use(SideBar);
    // Vue.use(Notifications);
    Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
    Vue.use(lineClamp, {});
  }
}
